<template>
  <div v-click-outside="closeEvent">
    <div class="orm-searchbar__headline">
      <strong>{{ title }}</strong>
    </div>
    <div
      class="orm-stationselect text-left"
      :class="{ 'orm-stationselect--disabled': readonly }"
    >
      <div>
        <div
          class="orm-stationselect__select orm-flex middle-sm"
          @click="openEvent"
          v-if="selected"
        >
          <strong> {{ selected[0] + optionlabel }}</strong>
          <div>
            <span class="orm-select_icon--right"
              ><i class="" :class="icon"></i
            ></span>
          </div>
        </div>
        <div v-else>
          <div
            class="orm-stationselect__select"
            @click="selectopen = !selectopen"
          >
            <span class="orm-select_icon--right"
              ><i class="" :class="icon"></i
            ></span>
          </div>
        </div>
        <div class="orm-stationselect__options" v-if="selectopen">
          <div
            class="orm-stationselect__option"
            :class="{ selected: selected[0] === option.key }"
            v-for="option in data"
            :selected="selected === option"
            :key="option"
            :value="option"
            @click="onChangeStation(option)"
          >
            <div>
              <strong
                class="orm-stationselect__select__textmiddle"
                :title="option"
                >{{ option[optionkey] + optionlabel }}</strong
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/mixins/mixins";
export default {
  mixins: [i18n],
  props: {
    title: String,
    data: Object,
    selected: Array,
    type: String,
    icon: String,
    optionkey: String,
    optionlabel: String,
    readonly: { type: Boolean, default: false },
    viewType: String,
    modelValue: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      selectopen: false,
    };
  },
  emits: ["selected"],
  methods: {
    openEvent() {
      if (!this.readonly) {
        this.selectopen = !this.selectopen;
      }
    },
    closeEvent() {
      this.selectopen = false;
    },
    onChangeStation(option) {
      this.$emit("selected", [option.key, option.value]);
      console.log(option);
      this.selectopen = false;
    },
  },
};
</script>
